export const INFORMATION_KINDS = ["video", "pdf"];
export const INFORMATION_CONTENT_TYPES = {
    video: "video/mp4",
    pdf: "application/pdf",
};
export const INFORMATION_LIMITS = {
    videoBytes: 128 * 1024 * 1024,
    pdfBytes: 50 * 1024 * 1024,
    videoSeconds: 180,
    posterBytes: 2 * 1024 * 1024,
    title: 120,
    description: 500,
    itemsPerPortal: 50,
};
export function informationKindOf(contentType) {
    var _a, _b;
    const ct = (_b = (_a = contentType.split(";")[0]) === null || _a === void 0 ? void 0 : _a.trim().toLowerCase()) !== null && _b !== void 0 ? _b : "";
    for (const kind of INFORMATION_KINDS) {
        if (INFORMATION_CONTENT_TYPES[kind] === ct)
            return kind;
    }
    return null;
}
export function maxBytesFor(kind) {
    return kind === "video"
        ? INFORMATION_LIMITS.videoBytes
        : INFORMATION_LIMITS.pdfBytes;
}
export function sniffMatches(kind, head) {
    const ascii = (from, len) => String.fromCharCode(...Array.from(head.subarray(from, from + len)));
    if (kind === "pdf")
        return head.length >= 5 && ascii(0, 5) === "%PDF-";
    return head.length >= 8 && ascii(4, 4) === "ftyp";
}
export const informationFileUrl = (id) => `/api/interactiveplayer/v1/portal/information/${encodeURIComponent(id)}/file`;
export const informationPosterUrl = (id) => `/api/interactiveplayer/v1/portal/information/${encodeURIComponent(id)}/poster`;
export function readInformationMeta(body, opts) {
    const b = (body && typeof body === "object" ? body : {});
    const meta = {};
    if ("title" in b || opts.requireTitle) {
        const title = typeof b.title === "string" ? b.title.trim() : "";
        if (!title)
            return { ok: false, problem: "title_required" };
        if (title.length > INFORMATION_LIMITS.title) {
            return { ok: false, problem: "title_too_long" };
        }
        meta.title = title;
    }
    if ("description" in b) {
        const description = typeof b.description === "string" ? b.description.trim() : "";
        if (description.length > INFORMATION_LIMITS.description) {
            return { ok: false, problem: "description_too_long" };
        }
        meta.description = description;
    }
    for (const key of ["publishedFrom", "publishedTo"]) {
        if (!(key in b))
            continue;
        const v = b[key];
        if (v === null || v === "") {
            meta[key] = null;
            continue;
        }
        if (typeof v !== "string" || Number.isNaN(Date.parse(v))) {
            return { ok: false, problem: "bad_date" };
        }
        meta[key] = new Date(v).toISOString();
    }
    if (meta.publishedFrom &&
        meta.publishedTo &&
        Date.parse(meta.publishedFrom) >= Date.parse(meta.publishedTo)) {
        return { ok: false, problem: "window_inverted" };
    }
    return { ok: true, meta };
}
export function isPublishedAt(item, now) {
    const t = now.getTime();
    const from = item.publishedFrom
        ? new Date(item.publishedFrom).getTime()
        : null;
    const to = item.publishedTo ? new Date(item.publishedTo).getTime() : null;
    if (from !== null && t < from)
        return false;
    if (to !== null && t >= to)
        return false;
    return true;
}
